import { call, takeLatest, put, all } from "redux-saga/effects";

import { storage } from "@/services";
import systemActions from "../actions/system";
import { api, queryBuilder } from "@/services";

function* ChangeLanguage(action) {
  storage.set("language", action.payload);
  yield put(systemActions.ChangeLanguage.success());
}

function* UploadFile(action) {
  const { files, cb } = action.payload;

  try {
    const { data } = yield call(
      api.request.post,
      queryBuilder("/filemanager/uploads"),
      files
    );

    yield put(systemActions.UploadFile.success({ files: data }));
    yield call(cb.success, data);
  } catch (e) {
    yield put(systemActions.UploadFile.failure(e));
    yield call(cb.failure, e);
  } finally {
    yield put(systemActions.UploadFile.fulfill());
    yield call(cb.finally);
  }
}

function* GetUnits() {
  try {
    const { data } = yield call(
      api.request.get,
      queryBuilder("/units", { sort: "sort" })
    );

    yield put(systemActions.GetUnits.success(data.data));
  } catch (e) {
    yield put(systemActions.GetUnits.failure(e));
  } finally {
    yield put(systemActions.GetUnits.fulfill());
  }
}

function* GetStorages() {
  try {
    const { data } = yield call(api.request.get, queryBuilder("/storages"));

    yield put(systemActions.GetStorages.success(data.data));
  } catch (e) {
    yield put(systemActions.GetStorages.failure(e));
  } finally {
    yield put(systemActions.GetStorages.fulfill());
  }
}

function* GetPaymentTypes() {
  try {
    const { data } = yield call(
      api.request.get,
      queryBuilder("/payment-types")
    );
    yield put(systemActions.GetPaymentTypes.success(data.data));
  } catch (e) {
    yield put(systemActions.GetPaymentTypes.failure(e));
  } finally {
    yield put(systemActions.GetPaymentTypes.fulfill());
  }
}

function* GetOrganizations() {
  try {
    const { data } = yield call(
      api.request.get,
      queryBuilder("/branches", {
        sort: "-id",
        extra: {
          per_page: 30,
        },
      })
    );
    yield put(systemActions.GetOrganizations.success(data.data));
  } catch (e) {
    yield put(systemActions.GetOrganizations.failure(e));
  } finally {
    yield put(systemActions.GetOrganizations.fulfill());
  }
}

export default function* root() {
  yield all([
    takeLatest(systemActions.ChangeLanguage.TRIGGER, ChangeLanguage),
    takeLatest(systemActions.GetStorages.TRIGGER, GetStorages),
    takeLatest(systemActions.UploadFile.TRIGGER, UploadFile),
    takeLatest(systemActions.GetPaymentTypes.TRIGGER, GetPaymentTypes),
    takeLatest(systemActions.GetUnits.TRIGGER, GetUnits),
    takeLatest(systemActions.GetOrganizations.TRIGGER, GetOrganizations),
  ]);
}
